<template>
    <div class="container">
            <div class="seach-container">
                    <div class="form-container">
                        <div class="form-box-item">
                            <div class="form-box-item-label">
                            <span class="letterspance2">用户姓名</span>
                            </div>
                            <div class="form-box-item-item">
                            <el-input
                                v-model="query.keyword"
                                size="small"
                                placeholder="请输入关键字"
                            ></el-input>
                            </div>
                        </div>
                    </div>   
                        <div class="form-container">
                        <div class="form-box-item">
                            <div class="form-box-item-label">
                            <span class="letterspance2">状态</span>
                            </div>
                            <div class="form-box-item-item">
                            <el-select v-model="query.state" size="small" placeholder="请选择">
                                  <!-- <el-option label="不控制" value="0"></el-option> -->
                                  <!-- 之前是可查看 -->
                                  <el-option label="待处理" value="1"></el-option>
                                  <el-option label="已处理" value="2"></el-option>
                                  <!-- <el-option label="全部" value="4"></el-option>  -->
<!--                                    <el-option label="可删除" value="5"></el-option>-->
                            </el-select>
                            </div>
                        </div>
                      </div>
                     <div class="form-container">
                        <div class="form-box-item serch-operate" >
                               <el-button type="primary" size="mini" icon="el-icon-search" @click="refreshList">搜索</el-button>
                               <el-button  icon="el-icon-delete" size="mini" @click="handleEmpty">清空</el-button>
                        </div>
                    </div>
            </div>
            <div class="addBtn">
                
            </div>
           <el-table
                :data="tableData"
                border
                :max-height="scrollHeight"
            >
                <el-table-column
                    v-for="col in tableCols"
                    :key="col.prop"
                    :prop="col.prop"
                    :label="col.label"
                    :width="col.width"
                    :align="col.align">
                        <template #default="scope">
                            <div v-if="(scope.column.property==='Operation')">
                                <el-button
                                 icon="el-icon-info"
                                size="mini"
                                type="info"
                                @click="handleView(scope.row)">查看</el-button>
                                 <el-button
                                 v-if="(scope.row.auditBtn==true)"
                                size="mini"
                                type="primary"
                                icon="el-icon-edit"
                                @click="handleBankAudit(scope.row)">银行经理审核</el-button>
                                <el-button
                                 v-if="(scope.row.auditFinalBtn==true)"
                                size="mini"
                                type="primary"
                                icon="el-icon-edit"
                                @click="handleBankBossAudit(scope.row)">银行部长审核</el-button>
                                   <el-button
                                   v-if="(scope.row.transferBtn==true)"
                                 icon="el-icon-d-arrow-right"
                                size="mini"
                                @click="handleTransfer(scope.row,2)">银行转交</el-button>
                                 <el-button
                                   v-if="(scope.row.appointBtn==true)"
                                 icon="el-icon-d-arrow-right"
                                size="mini"
                                @click="handleTransfer(scope.row,1)">银行分配</el-button>
                                  <el-button
                                v-if="(scope.row.acceptBtn==true)"
                                 icon="el-icon-check"
                                size="mini"
                                type="success"
                                @click="handleAccept(scope.row,1)">银行接收</el-button>
                               <el-button
                                 v-if="(scope.row.acceptBtn==true)"
                                size="mini"
                                type="success"
                                icon="el-icon-close"
                                @click="handleAccept(scope.row,2)">银行不接收</el-button>
                                <el-button
                                 v-if="(scope.row.auditDBBtn==true)"
                                size="mini"
                                type="primary"
                                icon="el-icon-edit"
                                @click="handleDBAudit(scope.row)">担保经理审核</el-button>
                                 <el-button
                                 v-if="(scope.row.auditFKBtn==true)"
                                size="mini"
                                type="primary"
                                icon="el-icon-edit"
                                @click="handleRiskDBAudit(scope.row)">风控审核</el-button>
                                <el-button
                                 v-if="(scope.row.auditFinalDBBtn==true)"
                                size="mini"
                                type="primary"
                                icon="el-icon-edit"
                                @click="handleMasterAudit(scope.row)">担保部长审核</el-button>
                                   <el-button
                                   v-if="(scope.row.transferDBBtn==true)"
                                 icon="el-icon-d-arrow-right"
                                size="mini"
                                @click="handleTransfer(scope.row,4)">担保转交</el-button>
                                 <el-button
                                   v-if="(scope.row.appointDBBtn==true)"
                                 icon="el-icon-d-arrow-right"
                                size="mini"
                                @click="handleTransfer(scope.row,3)">担保分配</el-button>
                                  <el-button
                                v-if="(scope.row.acceptDBBtn==true)"
                                 icon="el-icon-check"
                                size="mini"
                                type="success"
                                @click="handleAccept(scope.row,1)">担保接收</el-button>
                               <el-button
                                v-if="(scope.row.acceptDBBtn==true)"
                                 icon="el-icon-close"
                                size="mini"
                                type="success"
                                @click="handleAccept(scope.row,2)">担保不接收</el-button>
                                <el-button
                                v-if="(scope.row.contractBtn==true)"
                                 icon="el-icon-star-off"
                                size="mini"
                                type="success"
                                @click="handleContract(scope.row)">生成函</el-button>
                                <el-button
                                v-if="(scope.row.fzjlBtn==true)"
                                 icon="el-icon-circle-check"
                                size="mini"
                                type="success"
                                @click="handleFzjlOk(scope.row)">分管风控领导确认</el-button>
                                <el-button
                                v-if="(scope.row.zjlBtn==true)"
                                 icon="el-icon-circle-check"
                                size="mini"
                                type="success"
                                @click="handleZjlOk(scope.row)">分管业务领导确认</el-button>
                              <el-button
                                  v-if="(scope.row.deleteBtn==true)"
                                 icon="el-icon-delete"
                                size="mini"
                                type="danger"
                                @click="handleDelete(scope.row)">终止</el-button>
                                
                            </div>
                            <div v-else-if="(scope.column.property==='State')">
                               <span v-if="(scope.row.State==5)">已完成</span>
                               <span v-else-if="(scope.row.State==4)">
                                  <span style="color:red" v-if="(scope.row.RefuseType==1)">
                                      银行经理拒绝
                                  </span>
                                  <span style="color:red" v-if="(scope.row.RefuseType==2)">
                                      银行部长拒绝
                                  </span>
                                  <span style="color:red" v-if="(scope.row.RefuseType==3)">
                                      担保经理拒绝
                                  </span>
                                  <span style="color:red" v-if="(scope.row.RefuseType==4)">
                                      担保部长拒绝
                                  </span>
                                  <span style="color:red" v-if="(scope.row.RefuseType==5)">
                                      长时间未缴费被拒绝
                                  </span>
<!--                                  <span style="color:red" v-if="(scope.row.RefuseType==6)">-->
<!--                                      长时间未签合同被拒绝-->
<!--                                  </span>-->
                               </span>
                               <span v-else-if="(scope.row.State==3)">用户已撤销</span>
                               <span v-else-if="(scope.row.State==2)">
                                   <span v-if="(scope.row.RecallType==1)">被风控退回</span>
                                   <span v-else>被担保经理退回</span>
                               </span>
                               <span v-else-if="(scope.row.State==1)">
                                   <div v-if="(scope.row.Type===1)">
                                       <span v-if="(scope.row.Route==1)">分配担保经理</span>
                                       <span v-if="(scope.row.Route==5)">担保审核</span>
                                       <span v-if="(scope.row.Route==6)">确认担保金额</span>
                                       <span v-if="(scope.row.Route==7)">风控审核</span>
                                       <span v-if="(scope.row.Route==8&&Number(scope.row.GuaranteeFee)>0)">用户缴费</span>
                                       <span v-if="(scope.row.Route==8&&Number(scope.row.GuaranteeFee)===0)">出具担保函</span>
                                       <span v-if="(scope.row.Route==9)">确认收款</span>
                                       <span v-if="(scope.row.Route==10)">出具担保函</span>
                                       <span v-if="(scope.row.Route==11)">分管风控领导确认</span>
                                       <span v-if="(scope.row.Route==12)">分管风控领导确认</span>
                                   </div>
                                   <div v-if="(scope.row.Type===2)">
                                       <span v-if="(scope.row.Route==1)">分配银行经理</span>
                                        <span v-if="(scope.row.Route==2)">银行审核</span>
                                        <span v-if="(scope.row.Route==3)">银行部长审核</span>
                                        <span v-if="(scope.row.Route==4)">分配担保经理</span>
                                       <span v-if="(scope.row.Route==5)">担保审核</span>
                                       <span v-if="(scope.row.Route==6)">确认担保金额</span>
                                       <span v-if="(scope.row.Route==7)">风控审核</span>
                                       <span v-if="(scope.row.Route==8&&Number(scope.row.GuaranteeFee)>0)">用户缴费</span>
                                       <span v-if="(scope.row.Route==8&&Number(scope.row.GuaranteeFee)===0)">出具担保函</span>
                                       <span v-if="(scope.row.Route==9)">确认收款</span>
                                       <span v-if="(scope.row.Route==10)">出具担保函</span>
                                       <span v-if="(scope.row.Route==11)">分管风控领导确认</span>
                                       <span v-if="(scope.row.Route==12)">分管风控领导确认</span>
                                   </div>
                                   <div v-if="(scope.row.Type===3)">
                                       <span v-if="(scope.row.Route==1)">银行审核</span>
                                       <span v-if="(scope.row.Route==3)">银行部长审核</span>
                                        <span v-if="(scope.row.Route==4)">分配担保经理</span>
                                       <span v-if="(scope.row.Route==5)">担保审核</span>
                                       <span v-if="(scope.row.Route==6)">确认担保金额</span>
                                       <span v-if="(scope.row.Route==7)">风控审核</span>
                                       <span v-if="(scope.row.Route==8&&Number(scope.row.GuaranteeFee)>0)">用户缴费</span>
                                       <span v-if="(scope.row.Route==8&&Number(scope.row.GuaranteeFee)===0)">出具担保函</span>
                                       <span v-if="(scope.row.Route==9)">确认收款</span>
                                       <span v-if="(scope.row.Route==10)">出具担保函</span>
                                       <span v-if="(scope.row.Route==11)">分管风控领导确认</span>
                                       <span v-if="(scope.row.Route==12)">分管风控领导确认</span>
                                   </div>
                                   <div v-if="(scope.row.Type===4)">
                                       <span v-if="(scope.row.Route==1)">担保审核</span>
                                       <span v-if="(scope.row.Route==6)">确认担保金额</span>
                                       <span v-if="(scope.row.Route==7)">风控审核</span>
                                       <span v-if="(scope.row.Route==8&&Number(scope.row.GuaranteeFee)>0)">确认收款</span>
                                       <span v-if="(scope.row.Route==8&&Number(scope.row.GuaranteeFee)===0)">出具担保函</span>
                                       <span v-if="(scope.row.Route==10)">出具担保函</span>
                                       <span v-if="(scope.row.Route==11)">分管风控领导确认</span>
                                       <span v-if="(scope.row.Route==12)">分管风控领导确认</span>
                                   </div>
                               </span>
                            </div>
                            <div v-else-if="(scope.column.property === 'Type')">
                                {{getTypeName(scope.row[scope.column.property])}}
                            </div>
                            <div v-else>
                                {{scope.row[scope.column.property]}}
                            </div>
                        </template>
                    </el-table-column>
            </el-table>
          <div class="pagination">
                <el-pagination
                    background
                    @size-change="handleSizeChange"
                    @current-change="handlePageChange"
                    :current-page="query.pageIndex"
                    :page-sizes="[10, 20, 30, 40]"
                    :page-size="query.pageSize"
                    layout="total, sizes, prev, pager, next"
                    :total="pageTotal">
                </el-pagination>
            </div>
             <!-- 详情弹出框 -->
        <el-dialog title="贷款详情" v-model="detailVisible" width="55%" top="6vh">
            <el-form ref="detailForm"  :model="dataDetail" label-width="110px">
                <el-row>
                    <el-col :span="11">
                        <el-form-item label="用户名称：">
                             {{dataDetail.Name}}
                        </el-form-item>
                    </el-col>
                      <el-col :span="11">
                        <el-form-item label="申请金额：">
                             {{dataDetail.Money}}
                        </el-form-item>
                    </el-col>
                </el-row>
            </el-form>
        </el-dialog>

        <el-dialog title="选择人员" v-model="userVisible" width="55%" top="6vh">
          <el-form ref="detailForm"  :model="dataDetail" label-width="110px">
                <el-row>
                    <el-col :span="22">
                        <el-table
                              :data="userList"
                              border
                              :max-height="600">
                              <el-table-column
                                v-for="col in userCols"
                                :key="col.prop"
                                :prop="col.prop"
                                :label="col.label"
                                :width="col.width"
                                :align="col.align">
                                  <template #default="scope">
                                      <div v-if="(scope.column.property === 'Operation')">
                                          <span v-if="(getUserState(scope.row))">
                                              当前人选
                                          </span>
                                          <el-button
                                            v-else
                                          size="mini"
                                          type="primary"
                                          @click="chooseUser(scope.row)">选择</el-button>
                                      </div>
                                      <div v-else>
                                          {{scope.row[scope.column.property]}}
                                      </div>
                                  </template>
                              </el-table-column>
                      </el-table>
                  </el-col>
                </el-row>
            </el-form>
        </el-dialog>
        <BankAudit ref="bankAudit"></BankAudit>
        <BankBossAudit ref="bankBossAudit"></BankBossAudit>
        <LoanAudit ref="loanAudit"></LoanAudit>
        <LoanDetail ref="loanDetail" ></LoanDetail>
        <LoanRiskAudit ref="loanRiskAudit"></LoanRiskAudit>
        <LoanMasterInputMoney ref="loanMasterInputMoney"></LoanMasterInputMoney>
        <LoanContract ref="loanContract"></LoanContract>
        <LoanFzjlAudit ref="loanFzjlAudit"></LoanFzjlAudit>
        <LoanZjlAudit ref="loanZjlAudit"></LoanZjlAudit>
    </div>
</template>

<script>
import indexJs from "./index.js";
  export default indexJs;
</script>

<style scoped>
@import url(./assets/style/style.less);
.dialog-Btn{
    text-align: center;
}
</style>
